// extracted by mini-css-extract-plugin
module.exports = {"controls":"ImageCarousel_controls__yBqn4","root":"ImageCarousel_root__sa78_","indicator":"ImageCarousel_indicator__8i7J5"};